import React from 'react'
import { toast } from 'react-toastify'

import Error from '../misc/Error'
import createSubscription from '../../actions/createSubscription'
import updateSubscription from '../../actions/updateSubscription'
import deleteSubscription from '../../actions/deleteSubscription'
import FireflySubscription from '../misc/FireflySubscription'
import {
  Button,
} from '../../styles/buttons'

class Subscription extends React.Component {

  // https://stripe.com/docs/checkout#integration-custom
  componentDidMount() {
    this.stripeCheckout = window.StripeCheckout.configure({
      key: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
      locale: 'auto',
      image: 'https://stripe.com/img/documentation/checkout/marketplace.png',
      name: 'Heartstrings',
      description: 'Subscribe to Heartstrings',
      email: this.props.auth.email,
      allowRememberMe: false,
      amount: 20 * 100, // in cents
    })
  }

  newSubscription = () => {
    this.stripeCheckout.open({
      token: createSubscription,
    })
  }

  updatePaymentMethod = subscriptionId => {
    this.stripeCheckout.open({
      token: token => updateSubscription(subscriptionId, token),
    })
  }

  componentWillUnmount() {
    this.stripeCheckout.close()
  }

  render() {
    return <FireflySubscription>
      { ({error, isLoading, subscription}) => {
        
        if (error) {
          return <Error error={error} />
        }

        if (isLoading) {
          return <p>loading...</p>
        }

        if (!subscription) {
          return <div>
            <p>Upgrade to:</p>
            <ul>
              <li>Add unlimited people</li>
              <li>Custom groups (friends, family, etc)</li>
              <li>Group by city</li>
              <li>Support a solo developer :)</li>
            </ul>
            <Button onClick={this.newSubscription}>Subscribe for $50/year</Button>
            <p>
              <ion-icon style={{fontSize: '1rem', marginRight: '.25rem'}} name="lock"></ion-icon>
              secure checkout
            </p>
          </div>
        }

        if (subscription.stripeSubscriptionError) {
          return <div style={{color: 'red'}}>
            <p>Aw crap... there was an error updating your subscription.</p>
            <p style={{fontFamily: 'monospace'}}>{subscription.stripeSubscriptionError}</p>
            <Button onClick={() => deleteSubscription(subscription)}>Delete and try again</Button>
          </div>
        }

        if (subscription.tempStripePaymentTokenId) {
          return <p>Updating your subscription...</p>
        }

        const cancelConfirmation = `Are you sure you want to cancel your subscription? You won't have access to paid Heartstrings features.`

        return <div>
          <p>You are subscribed!</p>
          <Button onClick={() => this.updatePaymentMethod(subscription.id)}>Update payment method</Button>
          <Button onClick={() => {
            if (window.confirm(cancelConfirmation)) {
              deleteSubscription(subscription)
                .then( () => toast(`You're unsubscribed`))
            }
          }}>Cancel subscription</Button>
        </div>

      }}
    </FireflySubscription>
  }
}

export default Subscription



// WEBPACK FOOTER //
// ./src/views/account/Subscription.js